const SignalrConfig = {
  Hubs: [
    {
      ServerUrl: `${process.env.REACT_APP_MARKET_SIGNALR_ENDPOINT}/RealtimeHub`,
      Prefix: 'Realtime',
      RegisteredRemoteChanels: [],
    },
    {
      ServerUrl: `${process.env.REACT_APP_MARKET_SIGNALR_ENDPOINT}/MarketHub`,
      Prefix: 'Market',
      RegisteredRemoteChanels: [],
    },
    {
      ServerUrl: `${
        process.env.REACT_APP_MARKET_SIGNALR_ENDPOINT
      }/NotificationHub`,
      Prefix: 'Notification',
      RegisteredRemoteChanels: [],
    },
  ],
};

export default SignalrConfig;
